import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import { exception } from '@/exceptions/Exceptions';
import { convertToSnakeCase, removeWhiteSpaces } from '@/helpers/StringHelpers';

/**
 * Create url query string.
 *
 * @param {Object} parameters
 *
 * @returns {string}
 *
 * @throws {Error}
 */
export const createUrlQueryString = (parameters) => {
    if (!isObject(parameters) || isEmpty(parameters)) exception('Parameters is not a valid object.');

    return Object.keys(parameters)
        .map(function(key) {
            if (parameters[key] !== null) {
                return convertToSnakeCase(key) + '=' + parameters[key];
            }
        })
        .filter(function(option) {
            return option != null;
        })
        .join('&');
};

/**
 * Replace url parameter place holders with requested parameters.
 *
 * @param {String} baseUrl
 * @param {Array}  urlParameters
 *
 * @returns {String}
 *
 * @throws {Error}
 */
export const prepareUrl = (baseUrl, urlParameters) => {
    if (!isString(baseUrl) || isEmpty(baseUrl)) exception('Base url must be a string.');
    if (isEmpty(urlParameters)) exception('Url parameters can\'t be empty.');

    let url = baseUrl;

    // Find all the url parameter place holders e.g. $1, $2.
    let placeHolders = url.match(/\$\d/g);

    for (let index = 0; index < placeHolders.length; index++) {
        // remove all spaces from the string
        let replaceString = isString(urlParameters[index]) ? removeWhiteSpaces(urlParameters[index]) : urlParameters[index];

        url = url.replace(placeHolders[index], replaceString);
    }

    return url;
};

/**
 * Dynamically create a url with url parameters and query string if present.
 *
 * @param {String} baseUrl
 * @param {Array}  urlParameters
 * @param {Object} queryParameters
 *
 * @returns {String}
 *
 * @throws {Error}
 */
export const url = (baseUrl, urlParameters, queryParameters = {}) => {
    let url = urlParameters ? prepareUrl(baseUrl, urlParameters) : baseUrl;

    if (isEmpty(queryParameters)) return url;

    // Create url query string.
    let queryString = createUrlQueryString(queryParameters);

    return url.concat('?', queryString);
};
